export const selectReferralPartnerId = (state: ReduxState) => state.referralPartner?.id;
